export default __webpack_public_path__ + "alberta-patient-download.1c4375210516c8b38a78.svg";